import * as React from "react";
import { FC } from "react";
import KilkaSlowOMalarstwieSciennym from "./kilka_slow_o_malarstwie_sciennym";

export default (): FC => <KilkaSlowOMalarstwieSciennym />;
